import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { PopupType } from '../../models/property-popup-type.enum';

@Component({
  selector: 'pioneer-update-status-popup',
  templateUrl: './update-status-popup.component.html',
  styleUrls: ['./update-status-popup.component.css'],
})
export class UpdateStatusPopupComponent implements OnInit {

  propertyPopupType = PopupType.SEARCH;

  PopupType = PopupType;

  @ViewChild(ModalDirective)
  updateStatusModal: ModalDirective;


  config = {
    backdrop: 'static',
    keyboard: false
  };

  @Output()
  closed = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  cancel() {
    this.updateStatusModal.hide();
  }

  open(): void {
    this.propertyPopupType = PopupType.SEARCH;
    this.updateStatusModal.show();
  }

  private close(): void {
    this.closed.emit();
    this.updateStatusModal.hide();
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/agency-dashboard/update-status-popup/update-status-popup.component.ts